export default __webpack_public_path__ + "static/invoice-form-custom-d872bf0e6a878f23bbc159b018a1d2c3.jpg";